import { roleManagers, roleCandidates, roleAdmins } from '@/settings/roles'

export function checkRoleManager(role) {
  return roleManagers.includes(role)
}

export function checkRoleCandidate(role) {
  return roleCandidates.includes(role)
}

export function checkRoleAdmin(role) {
  return roleAdmins.includes(role)
}



// WEBPACK FOOTER //
// ./src/helpers/roles.js